import React, { useContext, useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
import SignupButton from './miniComponents/SignupButton'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'
import 'C:/apps/ideafy/src/components/styles/MainPageMobile.css'


const FirstSlide = ()=> {
    return (
        <div className = 'firstSlide'> 
            <div className = 'containerOne'>
                <div id = 'head'> 
                    <h1 className = 'heading'> IDEAFY </h1>
                    <div className = 'horizontalLine'> </div>
                </div>
                <div className = 'baseOne'>
                    <div id = 'descriptionBlock'>
                        <h1 id = 'descriptionHeading'>Place To Share and Discuss Ideas</h1>
                    </div>
                    <div>
                        <SignupButton/> 
                    </div>
                </div>
            </div>
        </div>
        // {/* <Link to='/create'> Create a Post </Link> */}
    )
}

export default FirstSlide 